import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@services/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/auth.service";
import * as i2 from "@angular/router";
var LoginGuard = /** @class */ (function () {
    function LoginGuard(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    LoginGuard.prototype.canActivate = function (route) {
        if (this.authService.loggedIn()) {
            this.router.navigate(['/profile'], { queryParams: { tab: 1 } });
            return false;
        }
        return true;
    };
    LoginGuard.ngInjectableDef = i0.defineInjectable({ factory: function LoginGuard_Factory() { return new LoginGuard(i0.inject(i1.AuthService), i0.inject(i2.Router)); }, token: LoginGuard, providedIn: "root" });
    return LoginGuard;
}());
export { LoginGuard };
